var _defs, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMyBookings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:rgba(54,54,54,0.8);}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H22V22H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.689,3H4.711A1.716,1.716,0,0,0,3,4.711V16.689A1.716,1.716,0,0,0,4.711,18.4H16.689A1.716,1.716,0,0,0,18.4,16.689V4.711A1.716,1.716,0,0,0,16.689,3Zm0,13.689H4.711V8.133H16.689ZM4.711,6.422V4.711H16.689V6.422ZM6.422,9.844h8.556v1.711H6.422Zm0,3.422h5.989v1.711H6.422Z",
    transform: "translate(0.3 0.3)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBookings);
export default __webpack_public_path__ + "static/media/myBookings.143bd2554c8441bd89f7e0ebaea1b6b1.svg";
export { ForwardRef as ReactComponent };